import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { api } from '../../lib/api';
import { SectionLabel, Reveal } from '../Section';

export default function Sponsors() {
  const [sponsors, setSponsors] = useState(null);
  const [failedLogos, setFailedLogos] = useState({});

  useEffect(() => {
    api
      .settings()
      .then((s) => setSponsors(Array.isArray(s.sponsors) ? s.sponsors.filter((sp) => sp && (sp.name || sp.logo_url)) : []))
      .catch(() => setSponsors([]));
  }, []);

  if (!sponsors || sponsors.length === 0) return null;

  return (
    <section className="py-16 sm:py-24 border-y border-white/5 bg-[#0a0a0a]" data-testid="sponsors-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionLabel testid="sponsors-label">Our Sponsors</SectionLabel>
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {sponsors.map((sp, i) => {
            const inner = (
              <>
                {sp.logo_url && !failedLogos[i] ? (
                  <img
                    src={sp.logo_url}
                    alt={sp.name || 'Sponsor'}
                    loading="lazy"
                    onError={() => setFailedLogos((f) => ({ ...f, [i]: true }))}
                    className="h-10 max-w-[140px] object-contain grayscale opacity-80 transition-[filter,opacity] duration-300 group-hover:grayscale-0 group-hover:opacity-100"
                  />
                ) : (
                  <span className="font-display text-white text-lg">{sp.name}</span>
                )}
                {sp.logo_url && !failedLogos[i] && sp.name && (
                  <span className="text-[11px] text-[#8a8a8a] font-semibold uppercase tracking-wider">{sp.name}</span>
                )}
              </>
            );
            const cls =
              'group card-surface card-surface-hover p-6 flex flex-col items-center justify-center gap-3 min-h-[110px] text-center';
            return (
              <Reveal key={`${sp.name || 'sponsor'}-${i}`} delay={(i % 5) * 0.06}>
                {sp.website_url ? (
                  <a
                    data-testid={`sponsor-card-${i}`}
                    href={sp.website_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={cls}
                  >
                    {inner}
                  </a>
                ) : (
                  <div data-testid={`sponsor-card-${i}`} className={cls}>
                    {inner}
                  </div>
                )}
              </Reveal>
            );
          })}
          <Reveal delay={(sponsors.length % 5) * 0.06}>
            <Link
              to="/collaborations"
              data-testid="sponsor-cta"
              className="p-6 flex flex-col items-center justify-center gap-3 min-h-[110px] text-center rounded-xl border border-dashed border-[#e8173a]/40 hover:border-[#e8173a] hover:bg-[#e8173a]/5 transition-colors duration-300"
            >
              <Plus className="w-5 h-5 text-[#e8173a]" />
              <span className="text-[11px] text-[#e8173a] font-extrabold uppercase tracking-wider">Become a Sponsor</span>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
